export { default as Img200 } from './processed/200/Barry-S2.jpg';
export { default as Img400 } from './processed/400/Barry-S2.jpg';
export { default as Imgthumb } from './processed/thumb/Barry-S2.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Barry-S2.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Barry-S2.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      220,
      34,
      44
    ],
    "_population": 31,
    "_hsl": [
      0.9910394265232975,
      0.7322834645669292,
      0.4980392156862745
    ]
  },
  "LightVibrant": {
    "_rgb": [
      236,
      142,
      92
    ],
    "_population": 3,
    "_hsl": [
      0.05787037037037038,
      0.7912087912087913,
      0.6431372549019608
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      111,
      6,
      11
    ],
    "_population": 1781,
    "_hsl": [
      0.9920634920634921,
      0.8974358974358974,
      0.22941176470588237
    ]
  },
  "Muted": {
    "_rgb": [
      165,
      109,
      81
    ],
    "_population": 171,
    "_hsl": [
      0.055555555555555546,
      0.34146341463414637,
      0.4823529411764706
    ]
  },
  "DarkMuted": {
    "_rgb": [
      88,
      56,
      53
    ],
    "_population": 10,
    "_hsl": [
      0.01428571428571427,
      0.2482269503546099,
      0.27647058823529413
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Barry-S2.js